import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import ValidationOtp from 'views/auth/validationOtp/ValidationOtp';
import Page404 from 'views/auth/error/Page404';
import PdfViewer from 'views/pdfViewer/PdfViewer';
import BatchPdfViewerPage from 'views/pdfViewer/BatchPdfViewerPage';

// Lista de rutas del aplicativo
export const NavigationRoutes = () => (

  <div>
    <Switch>
      <Route exact path="/apiv1/validation/:solicitudId" component={ValidationOtp} />
      <Route exact path="/apiv1/pdf-viewer/:solicitudId" component={PdfViewer} />
      <Route exact path="/apiv1/batch-pdf-viewer" component={BatchPdfViewerPage} />
      <Route exact path="/apiv1/error" component={Page404} />
      <Redirect to="/apiv1/error" />
    </Switch>
  </div>

);
